/* eslint-disable react/require-default-props */
import { Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

import { StatusCode } from '../../../api/enumerations';
import { getAssociatedList } from '../../../api/registryAssociation';
import { AssociationWOData } from '../../../api/registryAssociation/types';
import { IconDescriptionMS } from '../../../constants/icons';
import useErrorMessage from '../../../hooks/useErrorMessage';
import { SectionBox } from '../../UI/Box';
import { SectionTitle } from '../../UI/Typography';
import AssociatedItem from './AssociatedItem';
import { Constants } from './constants';
import { CardsContainer } from './styles';

interface AssociatedWorkOrdersProps {
  osId: number | undefined;
  list?: AssociationWOData[];
}

export function AssociatedWorkOrders({
  osId,
  list,
}: AssociatedWorkOrdersProps): JSX.Element | null {
  const [associatedWorkData, setAssociatedWorkData] = useState<
    AssociationWOData[]
  >([]);

  const { logDevError } = useErrorMessage();

  const getAssociatedCallback = useCallback(async () => {
    try {
      if (!osId) return;
      const response = await getAssociatedList(osId);

      if (response.detail?.description) {
        throw new Error(response.detail.description);
      }

      if (response.detail.status_code !== StatusCode.OK) {
        throw new Error('Algo deu errado, tente novamente.');
      }

      if (response.data) {
        setAssociatedWorkData(response.data);
      }
    } catch (error) {
      logDevError(`Error on loading associated work orders: ${error}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [osId]);

  useEffect(() => {
    if (list) {
      setAssociatedWorkData(list);
    } else {
      getAssociatedCallback();
    }
  }, [getAssociatedCallback, list]);

  if (associatedWorkData.length === 0) {
    return null;
  }
  return (
    <SectionBox sx={{ margin: '0 0 20px' }}>
      <SectionTitle>
        {IconDescriptionMS}
        {Constants.associated}
      </SectionTitle>
      <Typography padding="16px 0">{Constants.previousWorkOrders}</Typography>
      <CardsContainer>
        {associatedWorkData.map((data) => (
          <AssociatedItem key={data.id} associatedData={data} />
        ))}
      </CardsContainer>
    </SectionBox>
  );
}
